import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";
import { PlainButton, Tooltip } from "../../../../primitives";

interface DrawerHeaderNavButtonProps {
  children: ReactNode;
  tip?: string;
  className?: string;
  onClick?: () => void;
}

export const DrawerHeaderNavButton: FC<DrawerHeaderNavButtonProps> = ({
  children,
  tip,
  className,
  onClick,
}) => (
  <Tooltip
    isDisabled={!tip}
    className="px-3"
    renderTrigger={({ ref, props }) => (
      <PlainButton
        ref={ref}
        className={cx(
          "rounded-lg transition-colors hover:bg-grey-200",
          className
        )}
        onClick={onClick}
        {...props}
      >
        {children}
      </PlainButton>
    )}
  >
    {tip}
  </Tooltip>
);
